import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';

import { ProjectSelectionsFacade } from '@mitsubishi/project/data-access';
import { DatasheetStatus, DownloadDocument } from '@mitsubishi/shared/data-access';

@Component({
  selector: 'apm-download-datasheet',
  templateUrl: './download-datasheet.component.html',
  styleUrls: ['./download-datasheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DownloadDatasheetComponent {
  @Input() disabled = false;
  @Input() datasheetStatus?: DatasheetStatus;
  @Input() document?: DownloadDocument;
  @Input() customFileName?: string;
  @Input() size = 'md';
  @Input() position = 'rigth';
  @Input() matTooltipPosition: TooltipPosition = 'right';
  @Input() matTooltipClass = 'tooltip-arrow-left';
  @Output() createDocument: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

  get documentIsComplete() {
    return this.datasheetStatus === DatasheetStatus.COMPLETE;
  }

  get documentIsInProgress() {
    return this.datasheetStatus === DatasheetStatus.PROGRESS;
  }

  constructor(private quoteFacade: ProjectSelectionsFacade) {}

  downloadDocument() {
    if (this.disabled) {
      return;
    }
    this.document?.fileName && this.quoteFacade.datasheetDownloadPdf(this.document?.fileName, this.customFileName);
  }

  onCreateDocument($event: MouseEvent) {
    if (this.disabled) {
      return;
    }
    return this.createDocument.emit($event);
  }
}
